/**
 * Toute page qui a dans sa sidebar un couple "Année" + "Scénarios
 * climatiques" doit basculer la liste déroulante d'année vers des niveaux de
 * réchauffement (+2°C / +2.7°C) quand le scénario choisi est TRACC : TRACC ne
 * raisonne pas en année (2035/2050) mais en niveau de réchauffement atteint.
 * Centralisé ici pour ne pas réécrire cette règle dans chaque page.
 */

/**
 * Les horizons proposés dans la sidebar, selon le scénario.
 * `avecReference: true` ajoute 2020 (resp. "reference") en tête, pour les
 * pages qui comparent aussi à la situation actuelle (ex. Tension).
 */
export function horizonsSelectionnables(scenario, { avecReference = false } = {}) {
  if (scenario === 'tracc') {
    return avecReference ? ['reference', '2', '2.7'] : ['2', '2.7'];
  }
  return avecReference ? [2020, 2035, 2050] : [2035, 2050];
}

/** Libellé affiché pour un horizon, selon le scénario. */
export function libelleHorizon(scenario, horizon) {
  if (scenario !== 'tracc') return String(horizon);
  return horizon === 'reference' ? 'Référence' : `+${horizon} °C`;
}

/**
 * Clé à utiliser dans YEAR_COLORS (constants.js) pour un horizon donné : en
 * TRACC les clés de couleur sont préfixées d'un "+" ("+2", "+2.7"), alors que
 * les horizons internes ne le sont pas ("2", "2.7").
 */
export function cleCouleurHorizon(scenario, horizon) {
  if (scenario !== 'tracc') return horizon;
  return horizon === 'reference' ? 'reference' : `+${horizon}`;
}
